module.exports = __webpack_public_path__ + "static/media/begin_ckt.5d34399c.png";